import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface ApprovalConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const ApprovalConfig: React.FC<ApprovalConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="Jóváhagyás beállítások">
        <ConfigField
          label="Jóváhagyó email címe"
          description="Ki hagyja jóvá ezt a lépést"
        >
          <input
            type="email"
            value={node.data.config?.approver || ''}
            onChange={(e) => updateConfig('approver', e.target.value)}
            placeholder="vezeto@youcrm.hu"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <ConfigField
          label="Jóváhagyási üzenet"
          description="Az üzenet amit a jóváhagyó lát"
        >
          <textarea
            value={node.data.config?.message || ''}
            onChange={(e) => updateConfig('message', e.target.value)}
            placeholder="Kérem hagyja jóvá a következő műveletet..."
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="requireComment"
            checked={node.data.config?.requireComment || false}
            onChange={(e) => updateConfig('requireComment', e.target.checked)}
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
          />
          <label htmlFor="requireComment" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Kötelező megjegyzés
          </label>
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="autoApprove"
            checked={node.data.config?.autoApprove || false}
            onChange={(e) => updateConfig('autoApprove', e.target.checked)}
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
          />
          <label htmlFor="autoApprove" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Automatikus jóváhagyás (teszt mód)
          </label>
        </div>

        <ConfigField
          label="Timeout (óra)"
          description="Mennyi idő után járjon le a jóváhagyás"
        >
          <input
            type="number"
            value={node.data.config?.timeout || 24}
            onChange={(e) => updateConfig('timeout', parseInt(e.target.value))}
            min="1"
            max="168"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>
      </ConfigSection>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-3">
        <div className="text-xs text-blue-700 dark:text-blue-300">
          <strong>✅ Jóváhagyási folyamat:</strong>
          <br />• Email értesítés a jóváhagyónak
          <br />• Jóváhagyás/Elutasítás linkkel
          <br />• Két kimenet: <code>approved</code> és <code>rejected</code>
          <br />• Timeout esetén automatikus elutasítás
        </div>
      </div>
    </div>
  );
};

export default ApprovalConfig;
